(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veppie-cookie-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veppie-cookie-options')) {
    customElements.define('veppie-cookie-options', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('change', () => this.updateCount(), { signal });
        this.closest('form')?.addEventListener('submit', (event) => {
          const form = event.currentTarget;
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            form.reportValidity();
          }
        }, { capture: true, signal });
        this.updateCount();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateCount() {
        const count = this.querySelectorAll('input[type="radio"]:checked').length;
        const status = this.querySelector('[role="status"]');
        if (status) {
          status.textContent = this.dataset.counterTemplate.replace('__COUNT__', String(count));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
